@if (filter() && (active === true || defaultVisible || defaultHidden)) {
  <div class="style-preview" [class.disabled]="disabled" (click)="openStylePickerDialog()">
    <app-tooltip-wrapper [noPadding]="true" [border]="'around'" [right]="right" [rowStyle]="true">
      @if (hasRuleStyle()) {
        @if ((active === true && hidden) || (active !== true && defaultHidden)) {
          <span class="icon icon-eye-blocked"></span>
        } @else if (active !== true) {
          <span class="icon icon-eye"></span>
        } @else if (cosmeticOptions) {
          @if (cosmeticOptions.highlight && cosmeticOptions.minimapIconShape) {
            <app-minimap-icon [cosmeticOptions]="cosmeticOptions"></app-minimap-icon>
          } @else if (cosmeticOptions.highlight && cosmeticOptions.beam) {
            <app-highlight-beam-icon [highlightColor]="cosmeticOptions.highlightColor!"></app-highlight-beam-icon>
          } @else {
            <span class="icon icon-eye"></span>
          }
        }
      } @else {
        <span class="icon icon-pencil"></span>
      }
      <ng-template #tooltip>
        <div class="label-background" [style.background-image]="labelBackgroundImage()">
          <div class="item-label">
            <div app-label-viewer [displayOptions]="dummyDisplayable.displayOptions" [exampleName]="exampleName" [forceHidden]="(active === true && hidden) || (active !== true && defaultHidden)"
              [isCurrency]="isCurrency" [isWaystone]="isWaystone" [isPoe1Gem]="isPoe1Gem" [isQuestItem]="isQuestItem" [rarity]="rarity" [disableBackground]="true" [sockets]="sockets"
              [influence]="influence" [fractured]="fractured" [synthesised]="synthesised" [veiled]="veiled"></div>
          </div>
        </div>
      </ng-template>
    </app-tooltip-wrapper>
  </div>

  @if (dialogOpen) {
    <app-style-picker-dialog
      (close)="closeStylePickerDialog()"
      (styleUpdated)="onDialogStyleUpdated()"
      (customRuleStyleCleared)="onDialogCustomRuleStyleCleared()"
      [ruleId]="ruleId()"
      [isCurrency]="isCurrency"
      [displayable]="dummyDisplayable"
      [exampleName]="exampleName"
      [isWaystone]="isWaystone"
      [isPoe1Gem]="isPoe1Gem"
      [isQuestItem]="isQuestItem"
      [rarity]="rarity"
      [sockets]="sockets"
      [influence]="influence"
      [fractured]="fractured"
      [synthesised]="synthesised"
      [veiled]="veiled"
      [allowDisactivate]="false"
      [allowHide]="false"
      [title]="title"></app-style-picker-dialog>
  }
}
